import {createUseStyles} from 'react-jss';

export default createUseStyles({
	logo: {
		width: '120px',
		minWidth: '120px',
		height: '32px',
		background: 'rgba(255, 255, 255, .2)',
		borderRadius: '6px',
		marginInlineEnd: '24px',
		display: 'flex',
		alignItems: 'center',
		padding: '0 15px',
	},
});
